const SitePersonnelData = {
  sitePersonals: [
    {
      request_id: 0,
      site_id: 0,
      study_id: 0,
      personnel_id: 0,
      due_date: '2022-02-13',
      request_priority: 'Low',
      request_category: 'User Access',
      system: 'FICS-CTMS',
      message: 'string',
      request_to: 'string',
      created_by: 'string'
    },
    {
      request_id: 94329854,
      site_id: 0,
      study_id: 0,
      personnel_id: '379a11b6-2d25-4882-9322-b28c5dc799d8',
      due_date: '2022-02-13',
      request_priority: 'p1',
      request_category: 'cat1',
      system: 'sys1',
      message: 'chnaged msg',
      request_to: 'req1',
      created_by: 'string'
    }
  ],
  priorities: [
    {
      title: 'Low',
      id: 'Low'
    },
    {
      title: 'Medium',
      id: 'Medium'
    },
    {
      title: 'High',
      id: 'High'
    }
  ],
  requests_to: [
    {
      title: 'System Admin',
      id: 'System Admin'
    }
  ],
  systems: [
    {
      title: 'Study side FICS- CTMS',
      id: 'Study side FICS- CTMS'
    }
  ],
  categories: [
    {
      name: 'User access',
      key: 'User access',
      type: 'user_access',
      permission: 'MANAGE_USER_ACCESS'
    },
    {
      name: 'Modify Information',
      key: 'Modify Information',
      type: 'user_access',
      permission: 'MANAGE_USER_ACCESS'
    },
    {
      name: 'Revoke Access',
      key: 'Revoke Access',
      type: 'user_access',
      permission: 'MANAGE_USER_ACCESS'
    }
  ],
  roles: [
    {
      title: 'Principal investigator',
      id: 'Principal investigator'
    },
    {
      title: 'Sub-Investigator',
      id: 'Sub-Investigator'
    },
    {
      title: 'Research Coordinator',
      id: 'Research Coordinator'
    },
    {
      title: 'Research Nurse',
      id: 'Research Nurse'
    },
    {
      title: 'Pharmacist',
      id: 'Pharmacist'
    },
    {
      title: 'Regulatory Coordinator',
      id: 'Regulatory Coordinator'
    },
    {
      title: 'Patient Informatics Leader',
      id: 'Patient Informatics Leader'
    }
  ],
  fics_roles: [
    {
      title: 'PI',
      id: 'PI'
    },
    {
      title: 'PIL',
      id: 'PIL'
    },
    {
      title: 'CRA',
      id: 'CRA'
    },
    {
      title: 'Data Manager',
      id: 'Data Manager'
    }
  ],
  site_per_activities: [
    'Assessment of inc/ex criteria',
    'Informed consent/assent',
    'Vital signs(pulse, height, weight, BP, RR, temperature, pulse ox)',
    'Assess performance status',
    'Physical exams',
    'Medical history',
    'Orders for IP',
    'Administration of IP',
    'Dose limiting toxicity determination',
    'Maximum tolerated dose determination',
    'Dose modifications (including reductions, holds or restarts)',
    'Intake documentation of symptoms',
    'Assessment of grade using CTCAE',
    'Transcription of grades from CTCAE for abnormal lab results',
    'Assessment of clinical significance of labs',
    'Assessment of expectedness',
    'Assessment of relationship to test article (attribution/causality)',
    'SAE determination (ie.,event meets criteria for expidited reporting)',
    'Report to Sponsor as SAE',
    'Documentation of accountability and adherence by review of subject diary',
    'Documentation of accountability and adherence by count of test article returned by subject',
    'Drug/device receipt from the sponsor, storage, preparation, dispensation, destruction, unused returns to the sponsor, and related documentation',
    'Writing in subject’s medical record or research chart',
    'Subject Randomization',
    'Lab sample processing, shipping or receiving',
    'Evaluation of response results',
    'Assessment of primary study endpoints',
    'Physical assessments, cognitive tests (i.e. walk tests, strength tests, measurements, neurocognitive tests, etc.)',
    'Subject photography',
    'Subject Questionnaires, Patient Reported Outcomes',
    'IVRS/IWRS access',
    'Perform EKGs/ECGs on provided',
    'Maintain regulatory binder or essential documents (ISF)',
    'Data transfer from source documents to CRF',
    'Sign completed CRF',
    'Data query resolution',
    'Communications and submissions to sponsors, IRB, or federal authorities',
    'Directly supervise Clinical Research Assistants, Clinical Research Coordinators, & Research Nurses.',
    'Preparation of test article',
    'IP receipt, return, accountability',
    'Collect AE/SAE data',
    'Lab procedures/or collection for testing',
    'Other'
  ]
};

export default SitePersonnelData;
